'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */
import { CmsOffer } from '../../../types/cmsProduct';
import { currencyFormat } from '../../../utils/helpers/formatters';
import { currencyFormatterNoDecimal } from '../../../utils/number';
import { StaticText } from '../i18n';

interface SingSaverRewardProps {
  offers: CmsOffer[];
  staticText: StaticText;
  itemNumber: number | null;
  bulletColor: string;
}

export const SingSaverReward: React.FC<SingSaverRewardProps> = ({
  offers,
  staticText,
  itemNumber,
  bulletColor,
}) => {
  const gifts = offers.flatMap(
    (offer) =>
      offer.list_of_gifts?.map((g) => ({
        ...g,
        offerTitle: offer.offer_title,
      })) ?? [],
  );

  if (gifts.length === 0) return null;

  return (
    <div className="flex flex-col gap-spacing/gap/soft-8px">
      {itemNumber != null && (
        <h3 className="font-font-weight/title-2 text-font-size/title-2 leading-line-height/title-2 text-text/secondary">
          {`${itemNumber}. ${staticText.chooseSsReward?.replace(/^\d+\.\s*/, '')}`}
        </h3>
      )}
      <p className="font-font-weight/body-2 text-font-size/body-2 leading-line-height/body-2-relaxed text-text/secondary">
        {staticText.pickRewards}
      </p>
      <div className={`flex flex-col gap-spacing/gap/soft-12px ${bulletColor}`}>
        {gifts.map((gift) => {
          const giftValue = gift.gift?.gift_value;
          const price = giftValue?.price;
          const prefix = currencyFormat(giftValue?.prefix ?? '');
          const formattedPrice = price
            ? currencyFormatterNoDecimal.format(price)
            : '';
          const topUp =
            giftValue?.topup_amount && giftValue?.topup_label
              ? ` (${staticText.worth} ${prefix}${currencyFormatterNoDecimal.format(price ?? 0)}, ${staticText.topUpOnly?.toLowerCase()} ${prefix}${currencyFormatterNoDecimal.format(giftValue.topup_amount)})`
              : price
                ? ` (${staticText.worth} ${prefix}${formattedPrice})`
                : '';

          return (
            <div
              key={gift.gift?.uid}
              className="flex items-start gap-spacing/gap/soft-6px"
            >
              <span className="w-[18px] shrink-0 text-center font-font-weight/bullet-1 text-font-size/bullet-1 leading-line-height/bullet-1">
                •
              </span>
              <span className="text-font-size/body-2">
                <span className="font-semibold leading-line-height/bullet-2">
                  {gift.gift?.gift_title}
                </span>
                <span className="font-medium leading-line-height/bullet-2 text-text/secondary">
                  {topUp}
                </span>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
